import script from "./ProjectFormSecondStepV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectFormSecondStepV2.vue?vue&type=script&setup=true&lang=ts"

import "./ProjectFormSecondStepV2.vue?vue&type=style&index=0&id=0120e2bb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0120e2bb"]])

export default __exports__